module.exports = __webpack_public_path__ + "img/eurotech-logo.a64138d2.jpg";